import { getMetadataStorage } from "class-validator";
import { keys } from "./keys.js";
function getConstraintMetadata(metadataStorage, validationMetadata) {
    return validationMetadata.flatMap((md)=>metadataStorage.getTargetValidatorConstraints(md.constraintCls));
}
function forEachField(validationClass, callback) {
    const metadataStorage = getMetadataStorage();
    const targetValidationMetadata = metadataStorage.getTargetValidationMetadatas(validationClass, validationClass.name, true, false);
    const validationMetadataByPropertyName = metadataStorage.groupByPropertyName(targetValidationMetadata);
    for (const fieldName of keys(validationMetadataByPropertyName))callback(fieldName, getConstraintMetadata(metadataStorage, validationMetadataByPropertyName[fieldName]));
}
function convertValueToClassValue(type, value) {
    if ('date' === type && 'string' == typeof value) {
        const [year, month, day] = value.split('-').map((date)=>Number.parseInt(date, 10));
        const newDateValue = new Date(year, month - 1, day);
        if (Number.isNaN(newDateValue.getTime())) return value;
        return newDateValue;
    }
    return value;
}
function convertValuesToClass(ValidationClass, values) {
    const newValues = new ValidationClass();
    forEachField(ValidationClass, (fieldName, contraintMetadata)=>{
        const { type } = getFieldMetaDataFromValidationMetadata(contraintMetadata);
        newValues[fieldName] = convertValueToClassValue(type, values[fieldName]);
    });
    return newValues;
}
function getMetadata(validationClass) {
    const fieldsMetadata = {};
    forEachField(validationClass, (fieldName, metadata)=>{
        fieldsMetadata[fieldName] = null != metadata ? getFieldMetaDataFromValidationMetadata(metadata) : {
            isRequired: false,
            type: 'string',
            inputType: 'unknown'
        };
    });
    return fieldsMetadata;
}
function getFieldMetaDataFromValidationMetadata(contraintMetadata) {
    const types = new Set(contraintMetadata.map((vm)=>vm.name));
    const isRequired = types.has('isDefined') || types.has('isNotEmpty');
    let type = 'unknown';
    if (types.has('isString')) type = 'string';
    else if (types.has('isInt')) type = 'integer';
    else if (types.has('isDecimal')) type = 'decimal';
    else if (types.has('isDate')) type = 'date';
    else if (types.has('isEnum')) type = 'enum';
    else if (types.has('isArray')) type = 'array';
    else if (types.has('isBoolean')) type = 'boolean';
    let inputType = type;
    if (types.has('isEmail')) inputType = 'email';
    else if (types.has('isPhoneNumber')) inputType = 'phone';
    else if (types.has('isUrl')) inputType = 'url';
    else if (types.has('isCreditCard')) inputType = 'creditcard';
    return {
        isRequired,
        type,
        inputType
    };
}
export { convertValueToClassValue, convertValuesToClass, forEachField, getFieldMetaDataFromValidationMetadata, getMetadata };
